import * as countryCodes from 'country-codes-list';

const topCountries = [ 'BE', 'NL', 'LU', 'FR', 'DE', 'IT', 'ES', 'CZ', 'CL', 'UK', 'GB', 'US' ];

class CountryInformation {

  static getCountryCodes() {
    return countryCodes.customArray({ //returns an array of 252 objects
      name: '{countryNameEn}',
      localName: '{countryNameLocal}',
      code: '{countryCode}',
      dialCode: '{countryCallingCode}'
    });
  }

  static getTopCountries() {
    const allCodes = CountryInformation.getCountryCodes();
    const filtered = allCodes.filter((country) => {
      return topCountries.includes(country.code.toUpperCase());
    });

    filtered.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });

    return filtered;
  }

  static getNonTopCountries() {
    const allCodes = CountryInformation.getCountryCodes();
    const filtered = allCodes.filter((country) => {
      return !topCountries.includes(country.code.toUpperCase());
    });

    filtered.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });

    return filtered;
  }

  static getFlagEmoji(countryCode) {
    // See https://dev.to/jorik/country-code-to-flag-emoji-a21
    const codePoints = countryCode
      .toUpperCase()
      .split('')
      .map(char => 127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
  }

}

export default CountryInformation;